import React from 'react';
import './LoadingScreen.css'; // Asegúrate de crear este archivo para los estilos

const LoadingScreen = () => {
    return (
        <div className="loading-container">
            <div className="loading-content">
                <h1 className="titulo">Multiparametrics Nodes</h1>
                <p>Instituto de Investigacion para la Gestion Integrada de Zonas Costeras</p>
                <p>Email: jlloret@dcom.upv.es</p>
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        </div>
    );
};

export default LoadingScreen;
